import React, { Component } from 'react';

import { Modal } from "@randajan/react-form";
import "@randajan/react-form/css";

import './App.scss';


import Nav from "./Nav/Nav";
import About from "./About/About";
import Reference from "./Reference/Reference";
import Pricelist from "./Pricelist/Pricelist";
// import ContactForm from "./ContactForm/ContactForm";
import Foot from "./Foot/Foot";
import Background from "./Background/Background";

export default _=>{
  return (
    <Modal className="App">
      <Background/>
      <Nav />
      <About />
      {/* <Reference /> */}
      <Pricelist />
      {/* <ContactForm /> */}
      <Foot />
    </Modal>
  );
}